import React from 'react'
import SearchForm from '../components/SearchForm'
import KaiwaList from '../components/KaiwaList'
import { useCollection } from '../hooks/useCollection'

export default function Home() {
    const { documents, error } = useCollection('corpus-v2')

    return (
        <div>
            {error && <p>{error}</p>}
            {documents && <SearchForm data={documents}/>}
            {documents && <KaiwaList data={documents}/>}
        </div>
    )
}
